import { styled, Theme } from '@nexelem/deprecated-theme';
import { IconButton } from '@nexelem/components';

export const CustomIconButton = styled(IconButton)(({ theme }) => {
  const typedTheme = theme as Theme;
  const { getColor, hexToRGB } = typedTheme.palette;
  const { filters } = typedTheme.client.filters;
  return {
    width: typedTheme.spacing(10),
    height: typedTheme.spacing(10),
    ':focus': {
      backgroundColor: hexToRGB(getColor(filters.activeFilterIcon), 0.9),
    },
  };
});
